/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useTranslation } from 'react-i18next';
import { TableCell } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import useStyles from '../FOTableBodyStyle';
import { selectAuthUserData } from '../../../../redux/features/auth/auth.slice';
import { isIncluded } from './FOBodyCombinedCell';
import { Roles } from '../../../../shared/enums/Roles';
import CustomCheckbox from '../../../CustomCheckbox';

const CheckboxCell = (props) => {
  const { isRowSelected, handleSelectRow, item, cellData } = props;
  const [isAdmin, setIsAdmin] = useState(false);
  const userData = useSelector(selectAuthUserData);

  useEffect(() => {
    if (userData && userData.roles) {
      const hasRoleAdmin = isIncluded([Roles.END_USER_ADMIN], userData.roles);

      setIsAdmin(hasRoleAdmin);
    }
  }, [setIsAdmin, userData]);

  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <TableCell className={classes.noRightBorder}>
      <CustomCheckbox
        disabled={!isAdmin}
        checked={isRowSelected(item)}
        onChange={handleSelectRow(item)}
        className={classes.lineCheckbox}
        inputProps={
          !isRowSelected(item)
            ? { 'aria-label': t(cellData?.ariaLabel) }
            : { 'aria-label': t(cellData?.activeAriaLabel) }
        }
      />
    </TableCell>
  );
};

export default CheckboxCell;
